import {isMobile} from '../../../utils/viewport';

class Animation {
    constructor() {
        this.x = 0;
        this.y = 0;

        this.width = isMobile() ? 533.33 : 800;
        this.height = isMobile() ? 400 : 600;
        this.frames = 100;
        this.frame = -1;

        this.image = window.assets ? window.assets.images[`/source/${isMobile() ? 'mobile' : 'desktop'}/animations/skeleton_loop.png`] : null;
        this.fps = 60;
        this.nextFrameTimestamp = 0;
        this.loaded = false;
        this.loaded_animation = false;

        this.canvas = null;
        this.ctx = null;

        this.contentLoadedcontentLoaded = this.contentLoaded.bind(this); 
    }

    //8k/9k

    update() {
        this.frame++;
        if(this.frame >= (this.loaded_animation ? 240 : 100)) {
            if(this.loaded) {
                this.image = window.assets.images[`/source/${isMobile() ? 'mobile' : 'desktop'}/animations/skeleton_haha.png`];
                this.loaded_animation = true;
            }

            this.frame = 0;
        }
    }

    draw() {
        const y = Math.floor(this.frame / 10),
              x = this.frame % 10;

        this.ctx.clearRect(0, 0, this.width, this.height);
        this.ctx.drawImage(
            this.image,
            (x * this.width),
            (y * this.height),
            this.width,
            this.height,
            0,
            0,
            this.width,
            this.height
        )

        this.nextFrameTimestamp = Date.now() + Math.floor(1e3 / this.fps);
    }

    animate() {
        if(Date.now() >= this.nextFrameTimestamp) {
            this.update();
            this.draw();
        }
        
        requestAnimationFrame(this.animate.bind(this));
    }

    contentLoaded() {
        this.loaded = true;
    }

    init() {
        this.image = window.assets ? window.assets.images[`/source/${isMobile() ? 'mobile' : 'desktop'}/animations/skeleton_loop.png`] : null;
        this.canvas = document.createElement('canvas');
        this.canvas.width = this.width;
        this.canvas.height = this.height;
        this.ctx = this.canvas.getContext('2d');
        document.querySelector('.loader-animation').append(this.canvas);
        this.frame = 0;
        this.draw();
    }

    start() {
        this.loaded = false;
        this.image = window.assets ? window.assets.images[`/source/${isMobile() ? 'mobile' : 'desktop'}/animations/skeleton_loop.png`] : null;
        this.canvas = document.createElement('canvas');
        this.canvas.width = this.width;
        this.canvas.height = this.height;

        this.ctx = this.canvas.getContext('2d');

        document.querySelector('.loader-animation').append(this.canvas);

        requestAnimationFrame(this.animate.bind(this));
    }
}

export default new Animation();